import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const IGContext = createContext(null);

const STORAGE_KEY = "reachos.selectedIgAccountId";

export function IGAccountProvider({ children }) {
  const [accounts, setAccounts] = useState([]);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(STORAGE_KEY) || "global");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const list = await api.igListAccounts();
      setAccounts(list);
      // If selected account no longer exists, fall back to global
      if (selectedId !== "global" && !list.find(a => a.id === selectedId)) {
        setSelectedId("global");
        localStorage.setItem(STORAGE_KEY, "global");
      }
    } catch {
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  }, [selectedId]);

  useEffect(() => { refresh(); }, [refresh]);

  const select = (id) => {
    setSelectedId(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  const selected = selectedId === "global" ? null : accounts.find(a => a.id === selectedId);
  const isGlobal = selectedId === "global";

  return (
    <IGContext.Provider value={{ accounts, selectedId, selected, isGlobal, loading, select, refresh }}>
      {children}
    </IGContext.Provider>
  );
}

export const useIG = () => useContext(IGContext);
